var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_c('h2',{staticClass:"text-center mb-4"},[_vm._v("Gráfico Peso para la edad")]),_c('div',{staticClass:"text-center"},[_c('canvas',{staticStyle:{"max-width":"650px","width":"600px","height":"400px"},attrs:{"id":"myChart"}})])])
}]

export { render, staticRenderFns }